import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IMemberCardDetails, IPaymentDetails, IMemberDetails } from '../models/core/member.model';
import { AppConfigService } from "./app-config.service";
import { IPaymentResponse } from '../models/core/payment.model';
import { Person } from '../models/person.models';

@Injectable({
  providedIn: 'root'
})
export class PaymentDetailsService {


  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
  }

  get MembershipDetailsApiPath(): string { return this.appConfigService.getLoadedConfig().communityApiUrl + `/api/membershipdetails/`; }
  get PaymentApiPath(): string { return this.appConfigService.getLoadedConfig().communityApiUrl + `/api/payment/`; }
  get PersonApiPath(): string { return this.appConfigService.getLoadedConfig().communityApiUrl + `/api/person/`; }

  public getCommunityLink(): Observable<boolean> {
    return this.http.get<boolean>(this.MembershipDetailsApiPath + `HasCommunityLink`);
  }

  public getMemberDetails(): Observable<IMemberDetails> {
    return this.http.get<IMemberDetails>(this.PaymentApiPath + `GetMemberDetails`);
  }

  public getMemberCardDetails(): Observable<IMemberCardDetails> {
    return this.http.get<IMemberCardDetails>(this.PaymentApiPath + `GetMemberCardDetails`);
  }

  public getTransactionDetails(): Observable<IPaymentResponse> {
    return this.http.post<IPaymentResponse>(this.PaymentApiPath + `GetSagePayTransaction`, null);
  }

  public GetChatUserDetails(): Observable<Person>{
    return this.http.get<Person>(this.PersonApiPath);
  }
}
